/* =========================================================
   MUMUKI Theme — Slider, Carousel, Promo
   ========================================================= */

// ---------- 1. Full-width Slider with optional infinite loop (Hero, Feature) ----------
function initSliders() {
  document.querySelectorAll('[data-slider]').forEach((root) => {
    const track = root.querySelector('.hero-banner__track, .feature-banner__track');
    if (!track) return;

    const originalSlides = Array.from(track.children);
    if (originalSlides.length <= 1) return;

    const loop = root.dataset.loop === 'true';
    const realCount = originalSlides.length;

    if (loop) {
      const firstClone = originalSlides[0].cloneNode(true);
      const lastClone = originalSlides[realCount - 1].cloneNode(true);
      firstClone.dataset.clone = 'true';
      lastClone.dataset.clone = 'true';
      track.appendChild(firstClone);
      track.insertBefore(lastClone, originalSlides[0]);
    }

    const prev = root.querySelector('[data-slider-prev]');
    const next = root.querySelector('[data-slider-next]');
    const dots = root.querySelectorAll('[data-slider-dot]');

    const autoplay = root.dataset.autoplay === 'true';
    const speed = parseFloat(root.dataset.autoplaySpeed || 5) * 1000;
    const transition = parseFloat(root.dataset.transitionSpeed || 0.6);

    let current = 0;
    let timer = null;
    let isAnimating = false;

    const startOffset = loop ? 1 : 0;
    const easing = `transform ${transition}s cubic-bezier(0.4, 0, 0.2, 1)`;

    const setTransform = (index, animate) => {
      track.style.transition = animate ? easing : 'none';
      track.style.transform = `translateX(-${(index + startOffset) * 100}%)`;
    };

    const updateDots = () => {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === ((current % realCount) + realCount) % realCount));
    };

    const goTo = (index) => {
      if (isAnimating) return;
      isAnimating = true;
      current = index;
      setTransform(current, true);
      updateDots();
    };

    track.addEventListener('transitionend', () => {
      isAnimating = false;
      if (!loop) return;
      if (current >= realCount) {
        current = 0;
        setTransform(current, false);
      } else if (current < 0) {
        current = realCount - 1;
        setTransform(current, false);
      }
    });

    const start = () => {
      if (!autoplay) return;
      stop();
      timer = setInterval(() => {
        if (loop) goTo(current + 1);
        else goTo((current + 1) % realCount);
      }, speed);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    prev?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loop) goTo(current - 1);
      else goTo((current - 1 + realCount) % realCount);
      start();
    });
    next?.addEventListener('click', (e) => {
      e.preventDefault();
      if (loop) goTo(current + 1);
      else goTo((current + 1) % realCount);
      start();
    });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); start(); }));

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    let startX = 0, deltaX = 0;
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchmove', (e) => { deltaX = e.touches[0].clientX - startX; }, { passive: true });
    track.addEventListener('touchend', () => {
      if (Math.abs(deltaX) > 50) {
        if (loop) goTo(deltaX < 0 ? current + 1 : current - 1);
        else goTo(deltaX < 0 ? (current + 1) % realCount : (current - 1 + realCount) % realCount);
      }
      deltaX = 0;
      start();
    });

    setTransform(0, false);
    updateDots();
    start();
  });
}

// ---------- 2. Peek Carousel (Product Grid, Follow Us) ----------
function initCarousels() {
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    const items = Array.from(track.children);
    if (items.length === 0) return;

    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');

    const autoplay = root.dataset.autoplay === 'true';
    const speed = parseFloat(root.dataset.autoplaySpeed || 4) * 1000;
    const transition = parseFloat(root.dataset.transitionSpeed || 0.5);

    let current = 0;
    let timer = null;

    track.style.transition = `transform ${transition}s cubic-bezier(0.4, 0, 0.2, 1)`;

    const getStep = () => {
      if (items.length < 2) return items[0]?.getBoundingClientRect().width || 0;
      const a = items[0].getBoundingClientRect();
      const b = items[1].getBoundingClientRect();
      return b.left - a.left;
    };

    const getVisibleCount = () => {
      const wrapper = track.parentElement;
      const step = getStep();
      if (!step) return 1;
      return Math.max(1, Math.floor(wrapper.clientWidth / step + 0.1));
    };

    const getMax = () => Math.max(0, items.length - getVisibleCount());

    const goTo = (index) => {
      const max = getMax();
      current = Math.max(0, Math.min(index, max));
      const step = getStep();
      track.style.transform = `translateX(-${current * step}px)`;
    };

    const start = () => {
      if (!autoplay || items.length <= getVisibleCount()) return;
      stop();
      timer = setInterval(() => {
        const max = getMax();
        goTo(current >= max ? 0 : current + 1);
      }, speed);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    prev?.addEventListener('click', (e) => { e.preventDefault(); goTo(current - 1); start(); });
    next?.addEventListener('click', (e) => { e.preventDefault(); goTo(current + 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    let startX = 0, deltaX = 0;
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchmove', (e) => { deltaX = e.touches[0].clientX - startX; }, { passive: true });
    track.addEventListener('touchend', () => {
      if (Math.abs(deltaX) > 50) goTo(deltaX < 0 ? current + 1 : current - 1);
      deltaX = 0;
      start();
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => { current = Math.min(current, getMax()); goTo(current); }, 150);
    });

    goTo(0);
    start();
  });
}

// ---------- 3. Promo Banner (Equal padding + Dots + Infinite loop) ----------
function initPromoSliders() {
  document.querySelectorAll('[data-promo-slider]').forEach((root) => {
    const track = root.querySelector('[data-promo-track]');
    if (!track) return;

    const originalSlides = Array.from(track.children);
    if (originalSlides.length === 0) return;

    const loop = root.dataset.loop === 'true' && originalSlides.length > 1;
    const realCount = originalSlides.length;

    if (loop) {
      const firstClone = originalSlides[0].cloneNode(true);
      const lastClone = originalSlides[realCount - 1].cloneNode(true);
      firstClone.dataset.clone = 'true';
      lastClone.dataset.clone = 'true';
      track.appendChild(firstClone);
      track.insertBefore(lastClone, originalSlides[0]);
    }

    const dots = root.querySelectorAll('[data-promo-dot]');
    const autoplay = root.dataset.autoplay === 'true';
    const speed = parseFloat(root.dataset.autoplaySpeed || 5) * 1000;
    const transition = parseFloat(root.dataset.transitionSpeed || 0.6);

    let current = 0;
    let timer = null;
    let isAnimating = false;

    const startOffset = loop ? 1 : 0;
    const easing = `transform ${transition}s cubic-bezier(0.4, 0, 0.2, 1)`;

    const setTransform = (index, animate) => {
      track.style.transition = animate ? easing : 'none';
      track.style.transform = `translateX(-${(index + startOffset) * 100}%)`;
    };

    const updateDots = () => {
      const realIndex = ((current % realCount) + realCount) % realCount;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === realIndex));
    };

    const goTo = (index) => {
      if (isAnimating) return;
      isAnimating = true;
      current = index;
      setTransform(current, true);
      updateDots();
    };

    track.addEventListener('transitionend', () => {
      isAnimating = false;
      if (!loop) return;
      if (current >= realCount) {
        current = 0;
        setTransform(current, false);
      } else if (current < 0) {
        current = realCount - 1;
        setTransform(current, false);
      }
    });

    const start = () => {
      if (!autoplay || realCount <= 1) return;
      stop();
      timer = setInterval(() => {
        if (loop) goTo(current + 1);
        else goTo((current + 1) % realCount);
      }, speed);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); start(); }));

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    let startX = 0, deltaX = 0;
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchmove', (e) => { deltaX = e.touches[0].clientX - startX; }, { passive: true });
    track.addEventListener('touchend', () => {
      if (Math.abs(deltaX) > 50) {
        if (loop) goTo(deltaX < 0 ? current + 1 : current - 1);
        else goTo(deltaX < 0 ? (current + 1) % realCount : (current - 1 + realCount) % realCount);
      }
      deltaX = 0;
      start();
    });

    setTransform(0, false);
    updateDots();
    start();
  });
}

// ---------- 4. Add to Cart ----------
function initCart() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-variant-id]');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) {
      alert('Variant ID가 설정되지 않았습니다.');
      return;
    }

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = '담는 중...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Failed');
      btn.textContent = '✓ ADDED';
      setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1500);
    } catch (err) {
      btn.textContent = 'ERROR';
      setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1500);
    }
  });
}

// ---------- 5. Header (transparent on hero + sticky on scroll) ----------
function initHeader() {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  const overlayMode = header.dataset.overlay === 'true';
  const main = document.getElementById('MainContent');
  const firstSection = main?.firstElementChild;
  const heroFirst = firstSection?.classList.contains('hero-banner');

  if (overlayMode && heroFirst) {
    // Hero가 첫 섹션이면: body는 padding 없음, Hero가 화면 최상단부터 시작
    // 헤더는 fixed로 그 위에 떠 있음 (transparent)
    document.body.classList.add('has-transparent-header');
  } else {
    // Overlay 아니거나 첫 섹션이 Hero가 아니면: body padding으로 헤더 자리 확보
    document.documentElement.style.setProperty('--header-total-height', `${header.offsetHeight}px`);
  }

  // Scroll behavior
  const onScroll = () => {
    if (window.scrollY > 10) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  window.addEventListener('resize', () => {
    if (!(overlayMode && heroFirst)) {
      document.documentElement.style.setProperty('--header-total-height', `${header.offsetHeight}px`);
    }
  });
}

// ---------- 6. Drawers (Search & Menu) ----------
function initDrawers() {
  const overlay = document.querySelector('[data-drawer-overlay]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const menuDrawer = document.querySelector('[data-menu-drawer]');
  const searchInput = document.querySelector('[data-search-input]');

  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.hidden = false;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
    document.body.classList.add('drawer-open');
  };

  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    setTimeout(() => {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 350);
  };

  const closeAll = () => {
    [searchDrawer, menuDrawer].forEach(d => d?.classList.remove('is-open'));
    overlay?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    setTimeout(() => {
      [searchDrawer, menuDrawer, overlay].forEach(d => { if (d) d.hidden = true; });
    }, 350);
  };

  // Search toggle
  document.querySelector('[data-search-toggle]')?.addEventListener('click', () => {
    openDrawer(searchDrawer);
    setTimeout(() => searchInput?.focus(), 200);
  });
  document.querySelector('[data-search-close]')?.addEventListener('click', () => closeDrawer(searchDrawer));

  // Live search via Shopify Predictive Search
  let searchTimer;
  searchInput?.addEventListener('input', (e) => {
    clearTimeout(searchTimer);
    const q = e.target.value.trim();
    const grid = document.querySelector('[data-search-grid]');
    if (!grid) return;

    if (!q) {
      // Reset to default preview by reloading initial HTML — we just leave it
      return;
    }

    searchTimer = setTimeout(async () => {
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`;
        const res = await fetch(url);
        const data = await res.json();
        const products = data?.resources?.results?.products || [];

        if (products.length === 0) {
          grid.innerHTML = `<p style="grid-column:1/-1;color:#888;font-size:13px;">검색 결과가 없습니다.</p>`;
          return;
        }

        grid.innerHTML = products.map(p => `
          <a href="${p.url}" class="search-product">
            <div class="search-product__image">
              ${p.featured_image?.url ? `<img src="${p.featured_image.url}&width=400" alt="${p.title}" loading="lazy">` : ''}
            </div>
            <h4 class="search-product__title">${p.title}</h4>
            <p class="search-product__price">${p.price}</p>
          </a>
        `).join('');
      } catch (err) {
        console.error('Search failed:', err);
      }
    }, 250);
  });

  // Menu toggle
  document.querySelector('[data-menu-toggle]')?.addEventListener('click', () => openDrawer(menuDrawer));
  document.querySelector('[data-menu-close]')?.addEventListener('click', () => closeDrawer(menuDrawer));

  // Overlay click closes all
  overlay?.addEventListener('click', closeAll);

  // Esc key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
}

// ---------- 7. Announcement Bar (auto-rotating) ----------
function initAnnouncementBar() {
  const bar = document.querySelector('[data-announcement]');
  if (!bar) return;
  const track = bar.querySelector('[data-announcement-track]');
  const items = track?.children;
  if (!items || items.length <= 1) return;

  const speed = parseFloat(bar.dataset.autoplaySpeed || 4) * 1000;
  let current = 0;
  track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';

  setInterval(() => {
    current = (current + 1) % items.length;
    track.style.transform = `translateX(-${current * 100}%)`;
  }, speed);
}

// ---------- 8. Member Floating Banner (close on X) ----------
function initMemberBanner() {
  const banner = document.querySelector('[data-member-banner]');
  if (!banner) return;
  const closeBtn = banner.querySelector('[data-member-banner-close]');
  if (!closeBtn) return;

  // 세션 스토리지 체크 - 이미 닫은 경우 숨김
  if (sessionStorage.getItem('memberBannerClosed') === '1') {
    banner.classList.add('is-hidden');
    return;
  }

  closeBtn.addEventListener('click', () => {
    banner.classList.add('is-hidden');
    sessionStorage.setItem('memberBannerClosed', '1');
  });
}

// ---------- 9. Signup Celebration Modal ----------
function initSignupCelebration() {
  const modal = document.querySelector('[data-signup-celebration]');
  if (!modal) return;

  // 이미 본 경우 표시 안 함 (같은 세션에서 다른 페이지 이동해도 안 뜸)
  if (sessionStorage.getItem('signupCelebrationSeen') === '1') {
    modal.classList.add('is-hidden');
    return;
  }

  // 닫기 처리 (X 버튼 또는 배경 클릭)
  const closeElements = modal.querySelectorAll('[data-signup-celebration-close]');
  const closeModal = () => {
    modal.classList.add('is-hidden');
    sessionStorage.setItem('signupCelebrationSeen', '1');
  };
  closeElements.forEach(el => {
    el.addEventListener('click', closeModal);
  });

  // ESC 키로도 닫기
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.classList.contains('is-hidden')) {
      closeModal();
    }
  });

  // 모달 표시 중 body 스크롤 락
  document.body.style.overflow = 'hidden';
  // 닫힐 때 원복
  closeElements.forEach(el => {
    el.addEventListener('click', () => {
      document.body.style.overflow = '';
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initAnnouncementBar();
  initDrawers();
  initSliders();
  initCarousels();
  initPromoSliders();
  initCart();
  initMemberBanner();
  initSignupCelebration();
});